import { Route, Routes } from "react-router-dom";

import FacilityPage from "./pages/facility/FacilityPage";
import PatientSupportPage from "./pages/patient-support/PatientSupportPage";
import CareersPage from "./pages/careers/CareersPage";
import ContactPage from "./pages/contact-us/ContactPage";

import InjectablesPage from "./pages/products/InjectablesPage";
import SolidOralsPage from "./pages/products/SolidOralsPage";
import SupportiveCarePage from "./pages/products/SupportiveCarePage";
import FeaturedPortfolioPage from "./pages/products/FeaturedPortfolioPage";
import LegalPage from "./components/site/LegalPage";
import NotFoundPage from "./pages/NotFoundPage";

export default function AppRoutes({ HomeComponent }) {
  return (
    <Routes>
      <Route path="/" element={<HomeComponent />} />

      <Route path="/facility" element={<FacilityPage />} />
      <Route path="/patient-support" element={<PatientSupportPage />} />
      <Route path="/careers" element={<CareersPage />} />
      <Route path="/contact" element={<ContactPage />} />

      <Route path="/products/injectables/" element={<InjectablesPage />} />
      <Route path="/products/solid-orals" element={<SolidOralsPage />} />
      <Route path="/products/supportive-care" element={<SupportiveCarePage />} />
      <Route path="/products/featured-portfolio" element={<FeaturedPortfolioPage />} />
      <Route path="/privacy-policy" element={<LegalPage />} />
      <Route path="/terms-and-conditions" element={<LegalPage />} />

      {/* 404 — any unknown path shows the Not Found page */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
